/**
 *
 * 通过文件名生成oss链接
 * @param {*} filename
 * @returns
 */
export function genOssImage (filename) {
  return `https://mj-comfy-ui.oss-cn-shenzhen.aliyuncs.com/${filename}`
}
